import { Component } from '@angular/core';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-incorrect',
  templateUrl: './incorrect.component.html'
})
export class IncorrectComponent {

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private appService: AppService) { }

  //-- EVENTS ----------------------------------------------------------|

  onBack() {
    this.appService.redirectTo(this.appService._REGISTER);
    return false;
  }

  onKeydown(event: any){
    if(event.key === 'Enter'){
        this.onBack();
    }
  }

  //--------------------------------------------------------------------|
  
}